import React, { Suspense, useRef, useCallback } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

// constants
import Loader from '../../components/Common/Loader';
import { OutsideClickDetector } from '../../util/util-common.js';

// actions

// components & files
import AdminNavbar from '../../components/Navbars/AdminNavbar.js';
import SideBar from '../../components/Sidebar/Sidebar.js';
import FourZeroFour from '../../components/Common/pagenotfound.js';

const ProfileAdminPortal = props => {
  const {
    isLoggedIn,
    deviceSize,
    showSideBar,
    profileToggleReducer,
    userDetails,
    routesNew,
    restrictAtEditProfile,

    // useStates
    isMobileCall = false,

    // functions
    handleEditProfileToggle
  } = props;

  const location = useLocation();
  const sidenavRef = useRef(null);
  const sideNavOutsideClicked = OutsideClickDetector(sidenavRef, showSideBar);

  let matched = false;
  const profileToggleData = _.get(profileToggleReducer, 'data', {});
  const profileToggleType = _.get(profileToggleReducer, 'type');
  let keysLength = 0;
  if (profileToggleData) {
    keysLength = _.isEmpty(profileToggleData[profileToggleType])
      ? 0
      : Object.keys(profileToggleData[profileToggleType]).length;
  }

  const getBrandText = path => {
    let routes = routesNew;

    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
  };

  const _renderRoutes = useCallback(
    routesNew => {
      // -------------------------------------- New Changes --------------------------------------
      if (isLoggedIn) {
        return routesNew.map((prop, key) => {
          if (!prop.hasAccess) return;
          if (
            !_.isEmpty(userDetails) &&
            userDetails?.comesfrom !== 'ticket' &&
            prop.path === '/mytickets'
          )
            return;

          return (
            <Route
              key={`key_${key}`}
              path={prop.path}
              component={prop.component}
              // key={key}
            />
          );
        });
      } else {
        return routesNew.map((prop, key) => {
          if (_.includes(['/autologin', '/sso-auth', '/overview'], prop.path)) {
            return (
              <Route
                key={`key_${key}`}
                path={prop.path}
                component={prop.component}
                // key={key}
              />
            );
          } else if (isMobileCall && prop.path == '/myprofile') {
            return (
              <Route
                key={`key_${key}`}
                path={prop.path}
                component={prop.component}
                // key={key}
              />
            );
          } else {
            return (
              <Route
                key={`key_${key}`}
                path={prop.path}
                render={() => <Redirect to="/overview" />}
                // key={key}
              />
            );
          }
        });
      }
    },
    [isLoggedIn, routesNew, userDetails]
  );

  const _renderSideBar = () => {
    const isMobile = deviceSize.isMobile;

    return (
      <SideBar
        {...props}
        isMobile={isMobile}
        routes={routesNew}
        sideNavOutsideClicked={isMobile && sideNavOutsideClicked}
        restrictAtEditProfile={restrictAtEditProfile}
        handleEditProfileToggle={handleEditProfileToggle}
      />
    );
  };

  return (
    <>
      {/* ----- Navbar ----- */}
      {!isMobileCall &&
      !_.includes(window.location.hash, '#/autologin') &&
      !_.includes(window.location.hash, '#/sso-auth') ? (
        <AdminNavbar
          {...props}
          routes={routesNew}
          brandText={getBrandText(location.pathname)}
          pathname={location.pathname}
          handleEditProfileToggle={handleEditProfileToggle}
        />
      ) : (
        ''
      )}

      {/* ----- Mobile view | Sidebar ----- */}
      {isLoggedIn ? (
        <div
          ref={sidenavRef}
          className={`d-lg-none sidenav ${
            showSideBar ? 'sidenav-boxshadow' : ''
          }`}
          style={{
            transform:
              showSideBar == true ? 'translateX(0)' : 'translateX(-100%)'
          }}
        >
          {_renderSideBar()}
        </div>
      ) : (
        ''
      )}

      {/* ----- Web view | Sidebar - Content ----- */}
      <div
        className={`${isLoggedIn && 'container mx-auto'}`}
        style={{ ...(isLoggedIn ? { maxWidth: '80rem' } : {}) }}
      >
        <div className={`row main-content full-height-WO-header`}>
          {/* --- Sidebar --- */}
          {isLoggedIn && (
            <div
              className={`d-none d-sm-none d-md-none d-lg-block col-lg-1 col-xl-2 sidebar-container bg-white ${'sidenav-regular  scrollbar-hide-no-maxheight'}`}
              style={keysLength === 1 ? { borderRight: 'unset' } : {}}
            >
              <div className={''} style={{ height: '100%' }}>
                {_renderSideBar()}
              </div>
            </div>
          )}

          {/* --- Content --- */}
          <div
            className={`col-12 col-sm-12 col-md-12 p-0 ${
              isLoggedIn ? 'col-lg-11 col-xl-10' : 'col-lg-12 col-xl-12'
            }`}
          >
            <Suspense
              fallback={
                <>
                  <Loader />
                </>
              }
            >
              <Switch>
                {_renderRoutes(routesNew)}

                {/* gibrish url 404 redirect */}
                {!matched &&
                  _.map(routesNew, (r, key) => {
                    if (r.path === location.pathname) {
                      matched = true;
                    } else {
                      let filter = _.filter(
                        routesNew,
                        r => r?.path == location.pathname
                      );
                      if (!filter.length) {
                        return <FourZeroFour key={`key_${key}`} />;
                      }
                    }
                  })}

                {/* if this Route made open then all routes are going /overview */}
              </Switch>
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.isLoggedIn,
    deviceSize: state.deviceSize,
    showSideBar: state.showSidebar,
    deviceSize: state.deviceSize,
    eventDetails: state.eventDetails,
    profileToggleReducer: state.profileToggleReducer,
    userDetails: state.userDetails
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAdminPortal);
